import React from 'react';
import {createForum} from '@peerboard/core';
import {Helmet} from "react-helmet";
import { withRouter } from "../../router/withRouter";
import { SideNavBar } from '../../components/SideNavBar';

// Settings -> Hosting -> Board ID
const boardID = '288855';
// Settings -> Hosting -> Path Prefix
const pathPrefix = '/community';

// Somewhere in your routing configuration. Don't use exact attribute - you should allow all nested routes
// <Route path="<PATH PREFIX>" component={PageWithPeerboard} />

class PeerboardCommunity extends React.Component {
    constructor() {
        super();
        this.handleDashboardClick = this.handleDashboardClick.bind(this);
        this.handleAdminClick = this.handleAdminClick.bind(this);
    }
    containerRef = React.createRef();
    state = {
        forum: null,
        error: null,
        loading: true,
    };

    handleDashboardClick() {
        this.props.navigate('/');
    }

    handleAdminClick() {
        this.props.navigate('/admin')
    }

    //
    async createPeerBoard() {
        const options = {

            prefix: pathPrefix,

            // Recommended setting so that the forum container
            // will always occupy all available space
            minHeight: window.innerHeight,

            // Update your page title according to the forum state
            onTitleChanged: title =>
                window.document.title = 'Your title ' + title,

            // You can remove the loaded and forum will be showed to the user
            onReady: () => this.setState({
                loading: false,
            }),

            onFail: () => this.setState({
                error: "Failed to load forum...",
            }),
        };

        // Optional. Do this only if you want to implement seamless login https://community.peerboard.com/post/183197627?category=2097967386
        // Add auth token so the user will be authenticated when community is loaded
        //options.jwtToken = await axios.post('https://api.myapp.com/create-token-for-peerboard')

        this.forum = await createForum(boardID, this.containerRef.current, options);
    }

    componentDidMount() {
        this.createPeerBoard().catch(err => this.setState({
            error: err.message,
        }));
    }

    componentWillUnmount() {
        console.log(this.forum);
        if (this.forum) this.forum.destroy()
    }

    render() {
        return (
            <div>
                <div>
                    <div className="main-dashboard">
                        <Helmet>
                            <link rel="stylesheet" href="/assets/css/main.css"/>
                            <link rel="stylesheet" href="/assets/css/fontawesome-all.min.css"/>
                            <link rel="stylesheet" href="/assets/css/bootstrap.min.css"/>
                            <link rel="stylesheet" href="/assets/css/slick.css"/>
                            <link rel="stylesheet" href="/assets/css/responsive.css"/>
                        </Helmet>
                        {/* side bar */ }
                        <SideNavBar />
                        <div className="main-content collapsed">
                            <section className="header-bar">
                                <div className="row align-items-center">
                                    <div className="col-xl-3 col-md-12 col-2">
                                        <div className="property-item">
                                            <div className="property-img">
                                                <img src="/assets/img/property.png" alt=""/>
                                            </div>
                                            <div className="property-select">
                                                <select>
                                                    <option>New Heights</option>
                                                    <option>New Heights2</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="mobile-logo">
                                            <img className="img-fluid logo-light" src="/assets/img/logo-light.png"
                                                 alt=""/>
                                            <img className="img-fluid logo-dark" src="/assets/img/logo-dark.png"
                                                 alt=""/>
                                        </div>
                                    </div>
                                    <div className="col-xl-9 col-md-12 col-10">
                                        <div className="header-bar-right">
                                            <ul className="header-icons">
                                                <li className="dropdown">
                                                    <a className="dropdown-toggle" href="#" role="button"
                                                       id="dropdownMenuLink1"
                                                       data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src="/assets/img/topbar-icon1.png" alt=""/>
                                                    </a>
                                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                        <span className="triangle-arrow"/>
                                                    </div>
                                                </li>
                                                <li className="dropdown">
                                                    <a className="dropdown-toggle" href="#" role="button"
                                                       id="dropdownMenuLink2"
                                                       data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src="/assets/img/topbar-icon2.png" alt=""/>
                                                    </a>
                                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuLink2">
                                                        <span className="triangle-arrow"/>
                                                    </div>
                                                </li>
                                                <li className="dropdown">
                                                    <a className="dropdown-toggle" href="#" role="button"
                                                       id="dropdownMenuLink3"
                                                       data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src="/assets/img/topbar-icon3.png" alt=""/>
                                                    </a>
                                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuLink3">
                                                        <span className="triangle-arrow"/>
                                                    </div>
                                                </li>
                                                <li className="dropdown right">
                                                    <a className="dropdown-toggle" href="#" role="button"
                                                       id="dropdownMenuLink4"
                                                       data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src="/assets/img/topbar-icon4.png" alt=""/>
                                                    </a>
                                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuLink4">
                                                        <span className="triangle-arrow"/>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div className="account-details">
                                                <div className="account-author">
                                                    <img src="/assets/img/author.png" alt=""/>
                                                </div>
                                                <select>
                                                    <option>Anddy’s Makeover</option>
                                                    <option>Anddy’s Makeover2</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div ref={this.containerRef}></div>
                        </div>
                        {/*<footer className={`footer-area ${showFooter ? 'active' : ''}`}>*/}
                    </div>

                </div>
            </div>
        );
    }
}

export default withRouter(PeerboardCommunity);
